<div class="mobile-dialog">
	<div class="mobile-dialog-header visible-xs">
		<div [ngClass]="className" class="mobile-dialog-header-icon">
			<ng-container *ngIf="!icon; else icon" [ngSwitch]="true">
				<ng-container *ngSwitchCase="dialogType === 'info' || dialogType === 'default' || dialogType === 'confirm'">
					<svg fill="none" height="70" viewBox="0 0 73 74" xmlns="http://www.w3.org/2000/svg">
						<circle cx="36.5" cy="37" fill="#0357EE" fill-opacity="0.1" r="36.5"/>
						<path
							d="M37 59.5C24.5736 59.5 14.5 49.4264 14.5 37C14.5 24.5736 24.5736 14.5 37 14.5C49.4264 14.5 59.5 24.5736 59.5 37C59.4864 49.4208 49.4208 59.4864 37 59.5ZM34.75 43.75V48.25H39.25V43.75H34.75ZM34.75 25.75V39.25H39.25V25.75H34.75Z"
							fill="#0361F0"/>
					</svg>
				</ng-container>
				<ng-container *ngSwitchCase="dialogType === 'success'">
					<svg fill="none" height="70" viewBox="0 0 69 68" xmlns="http://www.w3.org/2000/svg">
						<circle cx="34.5" cy="34" fill="#1EB12D" fill-opacity="0.1" r="34"/>
						<circle cx="33.375" cy="32.875" fill="white" r="16.875"/>
						<path
							d="M34.5 56.5C22.0792 56.4864 12.0136 46.4208 12 34V33.55C12.2473 21.1852 22.4278 11.3379 34.794 11.502C47.1602 11.6661 57.0758 21.78 56.995 34.147C56.9142 46.5141 46.8673 56.4976 34.5 56.5ZM25.7603 34.6592C24.8829 33.7852 23.4635 33.7865 22.5878 34.6623C21.7109 35.5392 21.7109 36.9609 22.5878 37.8378L27.5714 42.8215C28.9127 44.1627 31.0873 44.1627 32.4286 42.8215L46.4137 28.8363C47.2907 27.9593 47.2932 26.5383 46.4194 25.6582C45.5411 24.7737 44.1114 24.7712 43.23 25.6526L30.5183 38.3643C30.2319 38.6507 29.7677 38.6511 29.4807 38.3653L25.7603 34.6592Z"
							fill="#1EB12D"/>
					</svg>
				</ng-container>
				<ng-container *ngSwitchCase="dialogType === 'error'">
					<svg _ngcontent-yqn-c298="" fill="none" height="70" viewBox="0 0 68 68" width="68"
						xmlns="http://www.w3.org/2000/svg">
						<circle _ngcontent-yqn-c298="" cx="34" cy="34" fill="#E94444" fill-opacity="0.1" r="34">
						</circle>
						<path _ngcontent-yqn-c298=""
							d="M34 56.5C21.5736 56.5 11.5 46.4264 11.5 34C11.5 21.5736 21.5736 11.5 34 11.5C46.4264 11.5 56.5 21.5736 56.5 34C56.4864 46.4208 46.4208 56.4864 34 56.5ZM31.75 40.75V45.25H36.25V40.75H31.75ZM31.75 22.75V36.25H36.25V22.75H31.75Z"
							fill="#E94444"></path>
					</svg>
				</ng-container>
				<ng-container *ngSwitchCase="dialogType === 'filter'">
					<svg fill="none" height="24" viewBox="0 0 38 38" width="32" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M21.9685 34.4375C21.778 34.4374 21.5888 34.4066 21.4081 34.3462L15.4595 32.3668C15.1057 32.2479 14.7984 32.0206 14.5812 31.717C14.364 31.4135 14.248 31.0493 14.2497 30.6761V21.8285C14.2481 21.8249 14.2458 21.8216 14.243 21.8188L1.72603 7.2393C1.44848 6.91596 1.26955 6.51976 1.21047 6.09775C1.15139 5.67574 1.21465 5.24564 1.39274 4.85852C1.57083 4.47139 1.85627 4.1435 2.21517 3.91377C2.57407 3.68404 2.99135 3.56213 3.41748 3.5625H34.5856C35.0118 3.56213 35.429 3.68404 35.7879 3.91377C36.1468 4.1435 36.4323 4.47139 36.6104 4.85852C36.7885 5.24564 36.8517 5.67574 36.7926 6.09775C36.7336 6.51976 36.5546 6.91596 36.2771 7.2393L23.7564 21.8203C23.7538 21.8233 23.7516 21.8265 23.7497 21.83V32.6562C23.7504 32.8904 23.7048 33.1223 23.6155 33.3387C23.5262 33.5551 23.3951 33.7518 23.2295 33.9173C23.064 34.0829 22.8673 34.214 22.6509 34.3033C22.4345 34.3926 22.2026 34.4382 21.9685 34.4375Z"
							fill="#0361F0"/>
					</svg>

				</ng-container>
				<ng-container *ngSwitchCase="dialogType === 'filter-bordered'">
					<div class="filter-bordered" nz-row nzAlign="middle" nzJustify="center"><img alt="funnel"
						src="assets/images/svgs/funnel.svg">
					</div>
				</ng-container>
				<ng-container *ngSwitchCase="dialogType === 'warning'">
					<svg fill="none" height="68" viewBox="0 0 68 68" width="68" xmlns="http://www.w3.org/2000/svg">
						<circle cx="34" cy="34" fill="#F08922" fill-opacity="0.1" r="34"/>
						<path
							d="M34 56.5C21.5736 56.5 11.5 46.4264 11.5 34C11.5 21.5736 21.5736 11.5 34 11.5C46.4264 11.5 56.5 21.5736 56.5 34C56.4864 46.4208 46.4208 56.4864 34 56.5ZM31.75 40.75V45.25H36.25V40.75H31.75ZM31.75 22.75V36.25H36.25V22.75H31.75Z"
							fill="#F08922"/>
					</svg>
				</ng-container>
				<ng-container *ngSwitchCase="dialogType === 'delete'">
					<svg _ngcontent-yqn-c298="" fill="none" height="70" viewBox="0 0 68 68" width="68"
						xmlns="http://www.w3.org/2000/svg">
						<circle _ngcontent-yqn-c298="" cx="34" cy="34" fill="#E94444" fill-opacity="0.1" r="34">
						</circle>
						<path _ngcontent-yqn-c298=""
							d="M34 56.5C21.5736 56.5 11.5 46.4264 11.5 34C11.5 21.5736 21.5736 11.5 34 11.5C46.4264 11.5 56.5 21.5736 56.5 34C56.4864 46.4208 46.4208 56.4864 34 56.5ZM31.75 40.75V45.25H36.25V40.75H31.75ZM31.75 22.75V36.25H36.25V22.75H31.75Z"
							fill="#E94444"></path>
					</svg>
				</ng-container>
				<ng-container *ngSwitchCase="dialogType === 'custom'" [ngTemplateOutlet]="thumbnailTpl">
				</ng-container>
			</ng-container>
		</div>
		<div class="mobile-dialog-title">{{ title }}</div>
	</div>
	<div class="mobile-dialog-body">
		<!-- <ng-container *ngIf="message">
     <div class="modal-dialog-text">{{message}}</div>
     <div class="m-t-40">
      <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="m-t-20">
        <div nz-col class="gutter-row" [nzSpan]="12">
          <button class="btn btn-secondary btn-block"
            (click)="cancelModalAlert()">{{'moniepoint.close'|translate}}</button>
        </div>
        <div nz-col class="gutter-row" [nzSpan]="12">
          <app-custom-submit-button [disabled]="!checked" [submitting]="submitting" [block]="true"
            (submitForm)="confirmAlert()" [name]="('moniepoint.confirm'|translate)">
          </app-custom-submit-button>
        </div>
      </div>


    </div>
   </ng-container> -->
		<ng-content></ng-content>
	</div>
</div>
